import React from "react";
import { fetchAllDataTypes } from "../data/datatypeutils";

function Dashboard() {
  fetchAllDataTypes();
  return <>Dashboard</>;
}

export default Dashboard;
